import React, { ReactNode } from "react";
import { Container, LazyloadImage } from "src/components";
import { IFullWidth } from "src/components/Layout/components/Container";
import styled from "styled-components";

import { IImage } from "../types";

interface IWrapper {
  padding: string;
  backgroundColor: string;
  backgroundImageUrl?: string;
}

const Wrapper = styled.div<IWrapper>`
  padding: ${({ padding }: IWrapper): string => padding};
  background-color: ${({ backgroundColor }: IWrapper): string =>
    backgroundColor};

  ${({ backgroundImageUrl }: IWrapper): string | undefined =>
    backgroundImageUrl &&
    `
      background-image: ${backgroundImageUrl};
      background-size: cover;
      background-position: center;
    `};

  img {
    max-width: 100%;
    height: auto;
  }
`;

const BannerImage = styled.img`
  display: block;
  width: 100%;
`;

interface IProps {
  children: ReactNode | ReactNode[];
  as?: React.ElementType;
  className?: string;
  padding?: string;
  backgroundColor?: string;
  backgroundImage?: IImage;
  backgroundAsImage?: boolean;
  noGutter?: boolean;
  fullWidth?: IFullWidth;
}

export const Slice = ({
  children,
  as = "section",
  className,
  padding = "20px",
  backgroundColor = "inherit",
  backgroundImage,
  backgroundAsImage,
  noGutter,
  fullWidth = "lg",
}: IProps): JSX.Element => {
  const backgroundImageUrl =
    backgroundImage?.url && `url(${backgroundImage.url})`;

  return (
    <Wrapper
      as={as}
      className={className}
      padding={backgroundAsImage ? "0" : padding}
      backgroundColor={backgroundColor}
      backgroundImageUrl={backgroundAsImage ? undefined : backgroundImageUrl}
    >
      {backgroundAsImage && (
        <LazyloadImage height={backgroundImage?.dimensions?.height}>
          <BannerImage src={backgroundImage?.url} />
        </LazyloadImage>
      )}
      <Container noGutter={noGutter} fullWidth={fullWidth}>
        {children}
      </Container>
    </Wrapper>
  );
};
